<div class="container">
  <p>Total Value ($) > {{minAmount}}</p>
  <nouislider
    [connect]="true"
    [config]="config"
    [(ngModel)]="modelRange"
    (ngModelChange)="onChange($event)"
  ></nouislider>
</div>
